window.APP = window.APP || {};
import jQuery from 'jquery';

APP.calendarAccessibility = (function ($) {
    'use strict';
    /**
     * Insert the presentational aria attribute to the calendar
     * @param {any} calendarID - calendar ID 
     */
    function initPresentationMode(calendarID) {
        $('#' + calendarID).find('.ui-datepicker-calendar').attr('role', 'presentation');
    }

    if (!String.prototype.format) {
        String.prototype.format = function (...args) {
            return this.replace(/(\{\d+\})/g, function (a) {
                return args[+(a.substr(1, a.length - 2)) || 0];
            });
        };
    }

    /**
     * Creates status message and updates the DOM
     * @param {string} startDate - start date
     * @param {string} endDate - end date
     * @param {string} messageId - ID assigned to the status message
     * @param {HTMLElement} appendTo - element to which to append the status message
     */
    function createStatusMessage(startDate, endDate, messageId, $appendTo, isUnselectable = false) {
        var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

        var start = new Date(startDate);
        var end = new Date(endDate);
        var statusMessage = "";
        var startDateFormatted = days[start.getDay()] + ' ' + start.getDate() + getSuffix(start.getDate()) + ' ' + months[start.getMonth()];

        var statusMessageElement = $('#' + messageId);

        var labelSelectedText = statusMessageElement.attr("data-selected-text");
        var labelOneNight = statusMessageElement.attr("data-one-night");
        var labelMultipleNight = statusMessageElement.attr("data-multiple-night");
        var labelValidationText = statusMessageElement.attr("data-validation-text");
        var labelChooseDate = statusMessageElement.attr("data-choose-date");
        var labelAccessibilityText = statusMessageElement.attr("data-accessibility-text")

        if (isUnselectable) {
            statusMessage = labelValidationText
        }
        else if (endDate == null && startDate !== null) {
            //const tommorrow = new Date(startDate)
            //const datePlus24hrs = new Date(tommorrow.setDate(tommorrow.getDate() + 1));
            //const datePlus24hrsFormatted = days[datePlus24hrs.getDay()] + ' ' + datePlus24hrs.getDate() + getSuffix(datePlus24hrs.getDate()) + ' ' + months[datePlus24hrs.getMonth()];
            statusMessage = labelOneNight.format(startDateFormatted, startDateFormatted);
        } else if(startDate == null) {
            statusMessage = labelAccessibilityText
        } else {
            var endDateFormatted = days[end.getDay()] + ' ' + end.getDate() + getSuffix(end.getDate()) + ' ' + months[end.getMonth()];
            var dateDifference = Math.ceil(Math.abs(end - start) / (1000 * 3600 * 24));
            statusMessage = labelMultipleNight.format(dateDifference == 1 ? 2 : dateDifference , startDateFormatted, endDateFormatted)
        }

        statusMessageElement.text(statusMessage);

        function getSuffix(day) {
            var daySuffix = "";

            switch (day) {
                case "1":
                    daySuffix = "st";
                    break;
                case "2":
                    daySuffix = "nd";
                    break;
                case "3":
                    daySuffix = "rd";
                    break;
                default:
                    daySuffix = "th";
                    break;
            }

            return daySuffix;
        }
    }

    function setTabIndexes(datePickerId) {

        var prev = $('#' + datePickerId + ' .ui-datepicker-prev'),
            next = $('#' + datePickerId + ' .ui-datepicker-next');

        next.attr('tabindex', '0');
        prev.attr('tabindex', '0');
    }

    /**
     * Initializes accessible calendar day links
     * @param {any} calendarId - calendar ID
     */
    function initDateAttributes(calendarId) {
        $('#' + calendarId + ' .ui-datepicker-calendar tbody td:has(a)').each(function (index) {
            var $link = $(this).find('a');

            var year = $(this).attr('data-year');
            var month = $(this).attr('data-month');
            var day = $link.text();

            var months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
            var days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

            var daySuffix = "";

            switch (day) {
                case "1":
                    daySuffix = "st";
                    break;
                case "2":
                    daySuffix = "nd";
                    break;
                case "3":
                    daySuffix = "rd";
                    break;
                default:
                    daySuffix = "th";
                    break;
            }

            var linkDate = new Date(+year, +month, +day);

            var linkDateFormatted = days[linkDate.getDay()] + ' ' + day + daySuffix + ' ' + months[linkDate.getMonth()];

            $link.attr('role', 'button');
            $link.attr('aria-pressed', false);
            $link.attr('aria-label', linkDateFormatted);
            //$link.attr('tabindex', '-1');

        });

        $('.ui-state-active').attr('aria-pressed', true);
        $('.ui-individual-date > a').attr('aria-pressed', true);
    }

    function initKeyboardNavigation(id) {
        var container = document.getElementById(id);
        var datepickerId = id;
        var isMultiColumn = $(container).find('.ui-datepicker-group').length > 0;

        initArrowNavigation();

        function initArrowNavigation() {
            // the top controls:
            var prev = $('.ui-datepicker-prev', container)[0],
                next = $('.ui-datepicker-next', container)[0];

            setTabIndexes(datepickerId);

            $('#' + datepickerId).on('keydown', function calendarKeyboardListener(keyVent) {
                var which = keyVent.which;
                var target = keyVent.target;
                var dateCurrent = getCurrentDate('#' + datepickerId);

                if (!dateCurrent) {
                    dateCurrent = $('a.ui-state-default')[0];
                    setHighlightState(dateCurrent, container);
                }

                if (27 === which) {
                    keyVent.stopPropagation();
                    return closeCalendar();
                } else if (which === 9 && keyVent.shiftKey) { // SHIFT + TAB
                    //keyVent.preventDefault();
                    //if ($(target).hasClass('ui-datepicker-close')) { // close button
                    //    $('.ui-datepicker-prev')[0].focus();
                    //} else if ($(target).hasClass('ui-state-default')) { // a date link
                    //    $('.ui-datepicker-close')[0].focus();
                    //} else if ($(target).hasClass('ui-datepicker-prev')) { // the prev link
                    //    $('.ui-datepicker-next')[0].focus();
                    //} else if ($(target).hasClass('ui-datepicker-next')) { // the next link
                    //    activeDate = $('.ui-state-highlight') ||
                    //        $('.ui-state-active')[0];
                    //    if (activeDate) {
                    //        activeDate.focus();
                    //    }
                    //}
                } else if (which === 9) { // TAB
                    //keyVent.stopPropagation();
                    //keyVent.preventDefault();
                    //setTimeout(function () {
                    //    $('.ui-datepicker-next').focus();
                    //}, 50);

                    //if ($(target).is(":focus") && ($(target).hasClass("ui-datepicker-next") || $(target).hasClass("ui-datepicker-prev"))) {
                    //    $('.ui-datepicker-next').focus();
                    //}

                    //if ($(target).hasClass('ui-datepicker-close')) { // close button
                    //    activeDate = $('.ui-state-highlight') ||
                    //        $('.ui-state-active')[0];
                    //    if (activeDate) {
                    //        activeDate.focus();
                    //    }
                    //} else if ($(target).hasClass('ui-state-default')) {
                    //    $('.ui-datepicker-next', container)[0].focus();
                    //} else if ($(target).hasClass('ui-datepicker-next')) {
                    //    $('.ui-datepicker-prev', container)[0].focus();
                    //} else if ($(target).hasClass('ui-datepicker-prev')) {
                    //    $('.ui-datepicker-close', container)[0].focus();
                    //}
                } else if (which === 37) { // LEFT arrow key
                    // if we're on a date link...
                    if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                        keyVent.preventDefault();
                        previousDay(target);
                    }
                } else if (which === 39) { // RIGHT arrow key
                    // if we're on a date link...
                    if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                        keyVent.preventDefault();
                        nextDay(target);
                    }
                } else if (which === 38) { // UP arrow key
                    if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                        keyVent.preventDefault();
                        upHandler(target, container, prev);
                    }
                } else if (which === 40) { // DOWN arrow key
                    if (!$(target).hasClass('ui-datepicker-close') && $(target).hasClass('ui-state-default')) {
                        keyVent.preventDefault();
                        downHandler(target, container, next);
                    }
                } else if (which === 13) { // ENTER
                    if ($(target).hasClass('ui-state-default')) {
                        setTimeout(function () {
                            $('#' + datepickerId + ' .ui-state-active').focus();
                        }, 50);
                    } else if ($(target).hasClass('ui-datepicker-prev')) {
                        handlePrevClicks();

                    } else if ($(target).hasClass('ui-datepicker-next')) {
                        handleNextClicks();

                    }
                } else if (32 === which) {
                    if ($(target).hasClass('ui-datepicker-prev') || $(target).hasClass('ui-datepicker-next')) {
                        target.click();
                    }
                } else if (33 === which) { // PAGE UP
                    moveOneMonth(target, 'prev');
                } else if (34 === which) { // PAGE DOWN
                    moveOneMonth(target, 'next');
                } else if (36 === which) { // HOME
                    var firstOfMonth = $(target).closest('tbody').find('.ui-state-default')[0];
                    if (firstOfMonth) {
                        firstOfMonth.focus();
                        setHighlightState(firstOfMonth, $('#' + datepickerId)[0]);
                    }
                } else if (35 === which) { // END
                    var $daysOfMonth = $(target).closest('tbody').find('.ui-state-default');
                    var lastDay = $daysOfMonth[$daysOfMonth.length - 1];
                    if (lastDay) {
                        lastDay.focus();
                        setHighlightState(lastDay, $('#' + datepickerId)[0]);
                    }
                }
                //$(".ui-datepicker-current").hide();
            });

        }

        function closeCalendar() {
            var container = $('#' + datepickerId);
            $(container).off('keydown');
            var input = $('#' + datepickerId)[0];
            $(input).datepicker('hide');

            input.focus();
        }

        ///////////////////////////////
        //////////////////////////// //
        ///////////////////////// // //
        // UTILITY-LIKE THINGS // // //
        ///////////////////////// // //
        //////////////////////////// //
        ///////////////////////////////

        function moveOneMonth(currentDate, dir) {
            var button = (dir === 'next')
                ? $('.ui-datepicker-next', container)[0]
                : $('.ui-datepicker-prev', container)[0];

            if (!button) {
                return;
            }

            var ENABLED_SELECTOR = '#' + datepickerId + ' tbody td:not(.ui-state-disabled)';
            var $currentCells = $(ENABLED_SELECTOR);
            var currentIdx = $.inArray(currentDate.parentNode, $currentCells);

            button.click();
            setTimeout(function () {
                updateHeaderElements();

                var $newCells = $(ENABLED_SELECTOR);
                var newTd = $newCells[currentIdx];
                var newAnchor = newTd && $(newTd).find('a')[0];

                while (!newAnchor) {
                    currentIdx--;
                    newTd = $newCells[currentIdx];
                    newAnchor = newTd && $(newTd).find('a')[0];
                }

                setHighlightState(newAnchor, $('#' + datepickerId)[0]);
                newAnchor.focus();

            }, 0);

        }

        function handleNextClicks() {
            setTimeout(function () {
                updateHeaderElements();
                prepHighlightState();

                $('.ui-datepicker-next').trigger('click');
                setTimeout(() => {
                    $('.ui-datepicker-next').focus();
                    $(".ui-datepicker-current").hide();
                }, 100)
            }, 0);
        }

        function handlePrevClicks() {
            setTimeout(function () {
                updateHeaderElements();
                prepHighlightState();

                $('.ui-datepicker-prev').trigger('click');
                setTimeout(() => {
                    $('.ui-datepicker-prev').focus();
                    $(".ui-datepicker-current").hide();
                }, 100)

            }, 0);
        }

        function previousDay(dateLink) {
            var container = document.getElementById(datepickerId);
            if (!dateLink) {
                return;
            }
            var td = $(dateLink).closest('td');
            if (!td) {
                return;
            }

            var prevTd = $(td).prev(),
                prevDateLink = $('a.ui-state-default', prevTd)[0];

            if (prevTd && prevDateLink) {
                setHighlightState(prevDateLink, container);
                prevDateLink.focus();
            } else {
                handlePrevious(dateLink);
            }
        }

        function handlePrevious(target) {
            var container = document.getElementById(datepickerId);
            if (!target) {
                return;
            }
            var currentRow = $(target).closest('tr');
            if (!currentRow) {
                return;
            }
            var previousRow = $(currentRow).prev();

            var isFirstCol = currentRow.parents('.ui-datepicker-group').hasClass('ui-datepicker-group-first');

            var filteredPrevRowCount = previousRow.find('td').filter(':not(.ui-datepicker-unselectable)').length;

            if (!previousRow || previousRow.length === 0 || filteredPrevRowCount === 0) {

                // there is not previous row, so we go to previous month...
                if (isFirstCol || !isMultiColumn) {
                    previousMonth();
                } else {
                    var trs = $('.ui-datepicker-group-first tr', container),
                        lastRowTdLinks = $('td a.ui-state-default', trs[trs.length - 1]),
                        lastDate = lastRowTdLinks[lastRowTdLinks.length - 1];

                    setHighlightState(lastDate, container);
                    lastDate.focus();
                }
            } else {
                var prevRowDates = $('td a.ui-state-default', previousRow);
                var prevRowDate = prevRowDates[prevRowDates.length - 1];

                if (prevRowDate) {
                    setTimeout(function () {
                        setHighlightState(prevRowDate, container);
                        prevRowDate.focus();
                    }, 0);
                }
            }
        }

        function previousMonth() {
            var prevLink = $('#' + datepickerId + ' .ui-datepicker-prev')[0];

            if (!$(prevLink).hasClass('ui-state-disabled')) {
                var container = document.getElementById(datepickerId);
                prevLink.click();
                // focus last day of new month
                setTimeout(function () {
                    var dates;

                    if (isMultiColumn) {
                        dates = $('.ui-datepicker-group-last td:not(.ui-datepicker-unselectable)')
                    } else {
                        dates = $('#' + datepickerId + ' td:not(.ui-datepicker-unselectable)')
                    }

                    var lastDate = $(dates[dates.length - 1]).find('a');

                    // updating the cached header elements
                    updateHeaderElements();

                    setHighlightState(lastDate, container);
                    lastDate.focus();

                }, 0);
            }

        }

        ///////////////// NEXT /////////////////
        /**
         * Handles right arrow key navigation
         * @param  {HTMLElement} dateLink The target of the keyboard event
         */
        function nextDay(dateLink) {
            var container = document.getElementById(datepickerId);
            if (!dateLink) {
                return;
            }
            var td = $(dateLink).closest('td');
            if (!td) {
                return;
            }
            var nextTd = $(td).next(),
                nextDateLink = $('a.ui-state-default', nextTd)[0];

            if (nextTd && nextDateLink) {
                setHighlightState(nextDateLink, container);
                nextDateLink.focus(); // the next day (same row)
            } else {
                handleNext(dateLink);
            }
        }

        function handleNext(target) {
            var container = document.getElementById(datepickerId);
            if (!target) {
                return;
            }
            var currentRow = $(target).closest('tr'),
                nextRow = $(currentRow).next();

            var isFirstCol = currentRow.parents('.ui-datepicker-group').hasClass('ui-datepicker-group-first');

            var filteredNextRowCount = nextRow.find('td').filter(':not(.ui-datepicker-unselectable)').length;
            if (!nextRow || nextRow.length === 0 || filteredNextRowCount === 0) {
                if (!isFirstCol || !isMultiColumn) {
                    nextMonth();
                } else {
                    var firstDate = $('.ui-datepicker-group-last a.ui-state-default', container)[0];
                    setHighlightState(firstDate, container);
                    firstDate.focus();
                }
            } else {
                var nextRowFirstDate = $('a.ui-state-default', nextRow)[0];
                if (nextRowFirstDate) {
                    setHighlightState(nextRowFirstDate, container);
                    nextRowFirstDate.focus();
                }
            }
        }

        function nextMonth() {
            var nextMon = $('#' + datepickerId + ' .ui-datepicker-next')[0];
            var container = document.getElementById(datepickerId);

            nextMon.click();

            // focus the first day of the new month
            setTimeout(function () {
                // updating the cached header elements
                updateHeaderElements();
                nextMon.click();
                var firstDate = $('a.ui-state-default', container)[0];


                setHighlightState(firstDate, container);
                firstDate.focus();
            }, 0);
        }

        /////////// UP ///////////
        /**
         * Handle the up arrow navigation through dates
         * @param  {HTMLElement} target   The target of the keyboard event (day)
         * @param  {HTMLElement} cont     The calendar container
         * @param  {HTMLElement} prevLink Link to navigate to previous month
         */
        function upHandler(target, cont, prevLink) {
            prevLink = $('.ui-datepicker-prev', container)[0];
            var rowContext = $(target).closest('tr');
            if (!rowContext) {
                return;
            }
            var rowTds = $('td', rowContext),
                rowLinks = $('a.ui-state-default', rowContext),
                targetIndex = $.inArray(target, rowLinks),
                prevRow = $(rowContext).prev(),
                prevRowTds = $('td', prevRow),
                parallel = prevRowTds[targetIndex],
                linkCheck = $('a.ui-state-default', parallel)[0];

            if (prevRow && parallel && linkCheck) {
                // there is a previous row, a td at the same index
                // of the target AND theres a link in that td
                setHighlightState(linkCheck, cont);
                linkCheck.focus();
            } else {
                // we're either on the first row of a month, or we're on the
                // second and there is not a date link directly above the target
                prevLink.click();
                setTimeout(function () {
                    // updating the cached header elements
                    updateHeaderElements();
                    var newRows = $('tr', cont),
                        lastRow = newRows[newRows.length - 1],
                        lastRowTds = $('td', lastRow),
                        tdParallelIndex = $.inArray(target.parentNode, rowTds),
                        newParallel = lastRowTds[tdParallelIndex],
                        newCheck = $('a.ui-state-default', newParallel)[0];

                    if (lastRow && newParallel && newCheck) {
                        setHighlightState(newCheck, cont);
                        newCheck.focus();
                    } else {
                        // theres no date link on the last week (row) of the new month
                        // meaning its an empty cell, so we'll try the 2nd to last week
                        var secondLastRow = newRows[newRows.length - 2],
                            secondTds = $('td', secondLastRow),
                            targetTd = secondTds[tdParallelIndex],
                            linkCheck = $('a.ui-state-default', targetTd)[0];

                        if (linkCheck) {
                            setHighlightState(linkCheck, cont);
                            linkCheck.focus();
                        }

                    }
                }, 0);
            }
        }

        //////////////// DOWN ////////////////
        /**
         * Handles down arrow navigation through dates in calendar
         * @param  {HTMLElement} target   The target of the keyboard event (day)
         * @param  {HTMLElement} cont     The calendar container
         * @param  {HTMLElement} nextLink Link to navigate to next month
         */
        function downHandler(target, cont, nextLink) {
            nextLink = $('.ui-datepicker-next')[0];
            var targetRow = $(target).closest('tr');
            if (!targetRow) {
                return;
            }
            var targetCells = $('td', targetRow),
                cellIndex = $.inArray(target.parentNode, targetCells), // the td (parent of target) index
                nextRow = $(targetRow).next(),
                nextRowCells = $('td', nextRow),
                nextWeekTd = nextRowCells[cellIndex],
                nextWeekCheck = $('a.ui-state-default', nextWeekTd)[0];

            if (nextRow && nextWeekTd && nextWeekCheck) {
                // theres a next row, a TD at the same index of `target`,
                // and theres an anchor within that td
                setHighlightState(nextWeekCheck, cont);
                nextWeekCheck.focus();
            } else {
                nextLink.click();

                setTimeout(function () {
                    // updating the cached header elements
                    updateHeaderElements();

                    var nextMonthTrs = $('tbody tr', cont),
                        firstTds = $('td', nextMonthTrs[0]),
                        firstParallel = firstTds[cellIndex],
                        firstCheck = $('a.ui-state-default', firstParallel)[0];

                    if (firstParallel && firstCheck) {
                        setHighlightState(firstCheck, cont);
                        firstCheck.focus();
                    } else {
                        // lets try the second row b/c we didnt find a
                        // date link in the first row at the target's index
                        var secondRow = nextMonthTrs[1],
                            secondTds = $('td', secondRow),
                            secondRowTd = secondTds[cellIndex],
                            secondCheck = $('a.ui-state-default', secondRowTd)[0];

                        if (secondRow && secondCheck) {
                            setHighlightState(secondCheck, cont);
                            secondCheck.focus();
                        }
                    }
                }, 0);
            }
        }

        function prepHighlightState() {
            var highlight;
            var cage = document.getElementById(datepickerId);
            highlight = $('.ui-state-highlight', cage)[0] ||
                $('.ui-state-default', cage)[0];
            if (highlight && cage) {
                setHighlightState(highlight, cage);
            }
        }

        // Set the highlighted class to date elements, when focus is received
        function setHighlightState(newHighlight, container) {
            var prevHighlight = getCurrentDate(container);
            // remove the highlight state from previously
            // highlighted date and add it to our newly active date
            $(prevHighlight).removeClass('ui-state-highlight');
            $(newHighlight).addClass('ui-state-highlight');
        }

        // grabs the current date based on the highlight class
        function getCurrentDate(container) {
            var currentDate = $('.ui-state-highlight', container)[0];
            return currentDate;
        }

        function updateHeaderElements() {
            var context = document.getElementById(datepickerId);
            if (!context) {
                return;
            }

            //  $(context).find('table').first().attr('role', 'grid');

            var prev = $('.ui-datepicker-prev', context)[0];
            var next = $('.ui-datepicker-next', context)[0];

            next.setAttribute('role', 'button');
            prev.setAttribute('role', 'button');
            //appendOffscreenMonthText(next);
            //appendOffscreenMonthText(prev);

            //$(next).on('click', handleNextClicks);
            //$(prev).on('click', handlePrevClicks);

            // add month day year text
            //monthDayYearText();
        }
    }


    return {
        createStatusMessage: createStatusMessage,
        initDateAttributes: initDateAttributes,
        initKeyboardNavigation: initKeyboardNavigation,
        initPresentationMode: initPresentationMode,
        setTabIndexes: setTabIndexes,
    };

})(jQuery);
